export const StatusCode = {
  Unauthorized: 401,
  Forbidden: 403,
};

export const DEFAULT_REQUEST_TIMEOUT = 60000;
